import { gql } from '@apollo/client';
import { INSIGHT_FIELDS_FRAGMENT } from './fragments';

export const ADD_SIGNALS_TO_INSIGHT_MUTATION = gql`
  mutation AddSignalsToInsightOperation($insightId: ID!, $signalIds: [ID!]!) {
    addSignalsToInsight(insightId: $insightId, signalIds: $signalIds) {
      data {
        id
      }
    }
  }
`;

export const REMOVE_SIGNALS_FROM_INSIGHT_MUTATION = gql`
  mutation RemoveSignalsFromInsightOperation(
    $signalIds: [ID!]!
    $insightId: ID!
    $enableAIInsightSummary: Boolean = false
    $enableAgenticSecOps: Boolean = false
  ) {
    removeSignalsFromInsight(signalIds: $signalIds, insightId: $insightId) {
      data {
        ...InsightFields
      }
    }
  }
  ${INSIGHT_FIELDS_FRAGMENT}
`;

export const CREATE_INSIGHT_FROM_SIGNAL_MUTATION = gql`
  mutation CreateInsightFromSignalOperation($signalId: ID!, $enableAIInsightSummary: Boolean = false, $enableAgenticSecOps: Boolean = false) {
    createInsightFromSignal(signalId: $signalId) {
      data {
        ...InsightFields
      }
    }
  }
  ${INSIGHT_FIELDS_FRAGMENT}
`;
